// extracted by mini-css-extract-plugin
export default {"haberListesi":"HaberListesi_haberListesi__NvF84"};